var _style, _path, _path2, _line, _line2, _line3, _line4, _line5, _line6, _line7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgText(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 165 195",
    style: {
      enableBackground: "new 0 0 165 195"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);stroke:#1B0400;stroke-width:15;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#1B0400;stroke-width:15;stroke-miterlimit:10;}\n\t.st2{fill:none;stroke:#1B0400;stroke-width:10;stroke-linecap:round;stroke-miterlimit:10;}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 146.7042,
    y1: 13.5126,
    x2: -10.4874,
    y2: 170.7042,
    gradientTransform: "matrix(1 0 0 -1 4 200)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0012DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF367F"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M157.5,60v114.2c0,7.3-6,13.3-13.3,13.3H20.8c-7.3,0-13.3-6-13.3-13.3V20.8c0-7.3,6-13.3,13.3-13.3h85.3 c1.2,0,2.4,0.5,3.3,1.3C120,19.1,140,40,156.1,56.5C157,57.5,157.5,58.7,157.5,60z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M106.5,7.5v42c0,10,0,10,10,10h41"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 26.5,
    y1: 103.3,
    x2: 98.7,
    y2: 103.3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 24.4,
    y1: 123.3,
    x2: 73.3,
    y2: 123.3
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 24.4,
    y1: 143.3,
    x2: 122.2,
    y2: 143.3
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 24.4,
    y1: 163.4,
    x2: 135.4,
    y2: 163.4
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 26.5,
    y1: 83.3,
    x2: 126,
    y2: 83.3
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 26.5,
    y1: 63.2,
    x2: 80.9,
    y2: 63.2
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 26.5,
    y1: 43.2,
    x2: 86,
    y2: 43.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgText);
export default __webpack_public_path__ + "static/media/text.7124489e49a2e8d87223a027824f000d.svg";
export { ForwardRef as ReactComponent };